// extracted by mini-css-extract-plugin
module.exports = {"custom-url":"Step1_custom-url__3uDqP","link":"Step1_link__2yvNE"};